import { useContext, useState } from 'react';
import { IconOk, IconError } from '../img'
import { DataContext } from '../data/DataContext';
import { Input, ModalMsgCtrl } from '../components'
import { ValidateEmail } from '../../../utils/helpMain'
import http from '../../../services/http';
import { endPoints } from '../../../utils/constanst';
import {useModal} from '../hook';


const Step7 = () => {

    const { ReclamosInspeccionNI, setReclamosInspeccionNI } = useContext(DataContext);
    const [reenviarCorreo, setReenviarCorreo] = useState(false)
    const [errorMail, setErrorMail] = useState({ errorMessage: '', isValid: true } as IEmailValidationResult);
    const [touched, setTouched] = useState(false);
    const [newMail, setNewMail] = useState('');
    const loadingModal = useModal({ isloading: true, txtMsg: 'Cargando...', active: false } as IModalProps);
   

    const cssStyle = {
        display: 'flex', justifyContent: 'center'
    }

    const finish = () => window.location.reload()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setNewMail(value)
        if (touched) setErrorMail(ValidateEmail(value));
    }

    const handleBlur = () => {
        setTouched(true);
        setErrorMail(ValidateEmail(ReclamosInspeccionNI.insuredMail));
    };

    const SendMail = async (e: React.FormEvent): Promise<void> => {
        e.preventDefault();

        const { errorMessage, isValid } = ValidateEmail(newMail);

        if (!isValid) {
            setErrorMail({ errorMessage, isValid });
            return;
        }

        try {
            loadingModal.show('Validando correo...');
            await http(endPoints.validateMail).post({
                correo: newMail,
                aplicacion: "Micro Rec Insp"
            });

            loadingModal.show('Enviando correo...');
            // Enviar correo de inspección
            await http(endPoints.sendMailInspectionNew(ReclamosInspeccionNI.id, newMail)).get();

            loadingModal.show('Cargando información...');
            const response = await http(endPoints.getInformationInspectionClaim(ReclamosInspeccionNI.id)).get();

            const inspectionData: IIformationIspection = JSON.parse(response.message);

            setReclamosInspeccionNI({
                ...ReclamosInspeccionNI,
                amountSentMail: inspectionData.CantidadCorreoEnviado,
                mailLog: inspectionData.BitacoraCorreo
            });
            setReenviarCorreo(false)
            loadingModal.hide();

        } catch (error) {
            loadingModal.hide();
            console.error("Error al enviar correo:", error);
            // msgModal.setTextError("Hubo un error al enviar el correo. Intente nuevamente.");
        }
    };

    return (
        <>
            <div style={cssStyle} className='mt-10'>
                {ReclamosInspeccionNI.saved && <IconOk width={50} />}
                {!ReclamosInspeccionNI.saved && <IconError width={50} />}
            </div>
            <div style={{ ...cssStyle, color: '#018765', fontWeight: '600', fontSize: '23px' }} className='mt-20'>
                {ReclamosInspeccionNI.saved && <span>¡Todo listo!</span>}
                {!ReclamosInspeccionNI.saved && <span>¡Oops!</span>}
            </div>
            <div style={{ ...cssStyle, textAlign: 'center', color: '#4D4D4D', fontWeight: '600', fontSize: '15px' }}>
                {ReclamosInspeccionNI.saved && <span>Se generó el número de trámite <br></br>  {ReclamosInspeccionNI.numberProcedure}</span>}
                {!ReclamosInspeccionNI.saved && <span>Ocurrió un problema</span>}
            </div>

            <div className='mt-30' style={{ ...cssStyle, textAlign: 'center', color: '#4D4D4D', fontWeight: '600', fontSize: '15px' }}>
                Correo enviado a {ReclamosInspeccionNI.mailLog}
            </div>

            {!reenviarCorreo && <>
                {
                    ReclamosInspeccionNI.saved && <div style={{ ...cssStyle, color: '#4D4D4D', fontSize: '14px', textAlign: 'justify' }} className='mt-30' >
                        <span>Enviaremos al correo electrónico del asegurado los documentos necesarios para completar tu expediente de reclamos.</span>
                    </div>
                }
                {ReclamosInspeccionNI.saved && <div style={{ ...cssStyle, color: '#4D4D4D', fontSize: '14px', textAlign: 'justify' }} className='mt-10'>
                    <span>¿El cliente necesita ayuda? Indicar que puede continuar su trámite de reclamo a través de nuestro portal “Consulta y/o completa tu trámite”. También puede contactarnos a través de nuestro Whatsapp 8794-4040 o bien llamar a nuestro Call Center al 2255-8484.</span>
                </div>
                }
            </>
            }

            {reenviarCorreo && <div>
                <Input
                    id='newMail'
                    field='newMail'
                    onChange={handleChange}
                    label='Correo electrónico del Asegurado*'
                    value={newMail}
                    placeholder="Ejemplo: usuario@dominio.com"
                    ariainvalid={!errorMail.isValid}
                    error={!errorMail.isValid}
                    title={errorMail.errorMessage}
                    onBlur={handleBlur}

                />
            </div>}

            {!ReclamosInspeccionNI.saved && <div style={{ ...cssStyle, textAlign: 'center', color: '#4D4D4D', fontSize: '14px' }} className='mt-10'>
                <span>Revisaremos la información ingresada y de ser necesario, nuestros ejecutivos se contactarán contigo para confirmar datos y continuar el proceso de tu reclamo.</span>
            </div>
            }

            {reenviarCorreo && <div style={{ display: 'flex', justifyContent: 'space-between' }} className='mt-30 '>
                <button className='btn-re-ni back' onClick={() => setReenviarCorreo(false)}>Cancelar</button>
                <button className='btn-re-ni next' onClick={SendMail}>Reenviar correo</button>
            </div>}
            {ReclamosInspeccionNI.amountSentMail < 2 && !reenviarCorreo && <div style={cssStyle} className='mt-30 '>
                <button className='btn-re-ni back' onClick={() => setReenviarCorreo(true)}>Enviar nuevamente</button>
            </div>}

            {/* <div style={cssStyle} className='mt-30 '>
                <button className='btn-re-ni next' onClick={finish}>Finalizar</button>
            </div> */}
              <ModalMsgCtrl {...loadingModal.modal} closeModal={loadingModal.hide} />
          
        </>
    )
}
export { Step7 }